import { v4 as uuid } from "uuid";

export function generateReference(prefix) {
  const idStr = uuid().toString();
  if (!prefix) return idStr;
  return `${prefix}:${idStr}`;
}
